import { render, staticRenderFns } from "./ManagePagesModal.vue?vue&type=template&id=3413e5c7&scoped=true&"
import script from "./ManagePagesModal.vue?vue&type=script&lang=js&"
export * from "./ManagePagesModal.vue?vue&type=script&lang=js&"
import style0 from "./ManagePagesModal.vue?vue&type=style&index=0&id=3413e5c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3413e5c7",
  null
  
)

export default component.exports